
import { Component, Vue, Prop } from "vue-property-decorator";
import { getTems } from "@/request/ceping";
@Component({})
export default class Name extends Vue {
  @Prop()
  private visible: any;
  private visibleChange() {
    this.ifLiangbiao = this.visible;
    if (this.visible) {
      this.getData();
    }
  }
  private currentData: any = [
    {
      create_time: "2022-10-11 17:33:33",
      index: 0,
      template_id: "tem6345386d58c24d0087bbb258",
      名称: "既往冠心病史",
      简介: "",
      类别: "随访数据",
      评估类别: "",
    },
    {
      create_time: "2022-10-11 17:33:33",
      index: 1,
      template_id: "tem6345386d58c24d0087bbb259",
      名称: "危险因素",
      简介: "",
      类别: "随访数据",
      评估类别: "",
    },
    {
      create_time: "2022-10-11 17:33:33",
      index: 7,
      template_id: "tem6345386d58c24d0087bbb25a",
      名称: "营养习惯调查",
      简介: "",
      类别: "随访数据",
      评估类别: "",
    },
  ];
  private ifLiangbiao: any = false;
  private leftCheckedAll: any = false;
  private rightCheckedAll: any = false;
  private liangbiaoTem: any = [
    // 随访数据的量表tab
    {
      name: "随访数据",
      label: "随访数据",
    },
  ];
  private leftData: any = {};
  private rightData: any = {};
  private openSave() {
    console.log("右边数据");
    console.log(this.rightData);
  }
  private cancel() {
    this.$emit("cancel");
  }
  private isShowTitle(items: any) {
    let result = false;
    if (items) {
      items.forEach((ele: any) => {
        if (!ele.hide) {
          result = true;
        }
      });
    }
    return result;
  }
  private getNum(item: any) {
    let num = 0;
    this.liangbiaoTem.forEach((element: any) => {
      if (item[element.label]) {
        item[element.label].forEach((ele: any) => {
          if (!ele.hide) {
            num++;
          }
        });
      }
    });
    return num;
  }
  private getCheckedNum(item: any) {
    let num = 0;
    this.liangbiaoTem.forEach((element: any) => {
      if (item[element.label]) {
        item[element.label].forEach((ele: any) => {
          if (!ele.hide && ele.checked) {
            num++;
          }
        });
      }
    });
    return num;
  }
  private leftSelAll() {
    if (this.leftCheckedAll) {
      // 选中全部
      this.liangbiaoTem.forEach((item: any) => {
        if (this.leftData[item.label]) {
          this.leftData[item.label].forEach((ele: any) => {
            if (!ele.hide) {
              ele.checked = true;
            }
          });
        }
      });
      this.$forceUpdate();
    } else {
      // 取消全部选择
      this.liangbiaoTem.forEach((item: any) => {
        this.leftData[item.label].forEach((ele: any) => {
          ele.checked = false;
        });
      });
      this.$forceUpdate();
    }
  }
  private rightSelAll() {
    if (this.rightCheckedAll) {
      // 选中全部
      this.liangbiaoTem.forEach((item: any) => {
        if (this.rightData[item.label]) {
          this.rightData[item.label].forEach((ele: any) => {
            if (!ele.hide && !ele.disabled) {
              ele.checked = true;
            }
          });
        }
      });
    } else {
      // 取消全部选择
      this.liangbiaoTem.forEach((item: any) => {
        this.rightData[item.label].forEach((ele: any) => {
          ele.checked = false;
        });
      });
    }
  }
  private toLeft() {
    this.liangbiaoTem.forEach((item: any) => {
      this.rightData[item.label].forEach((ele: any) => {
        this.leftData[item.label].forEach((e: any) => {
          if (ele.template_id === e.template_id && !ele.hide && ele.checked) {
            // 改变左边数据
            e.checked = false;
            e.hide = false;
            // 改变右边数据
            ele.hide = true;
            ele.checked = false;
          }
        });
      });
    });
    // 清除左边选中的
    this.leftCheckedAll = false;
    this.rightCheckedAll = false;
    this.$forceUpdate();
  }
  private toRight() {
    this.liangbiaoTem.forEach((item: any) => {
      if (this.leftData[item.label] && this.leftData[item.label].length > 0) {
        this.leftData[item.label].forEach((ele: any) => {
          this.rightData[item.label].forEach((e: any) => {
            if (ele.template_id === e.template_id && !ele.hide && ele.checked) {
              // 改变右边数据
              e.checked = false;
              e.hide = false;
              // 改变左边数据
              ele.hide = true;
              ele.checked = false;
            }
          });
        });
      }
    });
    // 清除左边选中的
    this.leftCheckedAll = false;
    this.rightCheckedAll = false;
    this.$forceUpdate();
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    getTems(this, { 类别: "随访" }, loading)
      .then((res: any) => {
        loading.close();
        this.data = res;
        this.liangbiaoTem.forEach((item: any) => {
          if (this.data[item.label]) {
            this.data[item.label].forEach((ele: any) => {
              ele.checked = false;
            });
          }
        });
        this.leftData = JSON.parse(JSON.stringify(this.data));
        this.rightData = JSON.parse(JSON.stringify(this.data));
        // 右边全部为隐藏状态
        this.liangbiaoTem.forEach((item: any) => {
          if (this.rightData[item.label]) {
            this.rightData[item.label].forEach((ele: any) => {
              ele.hide = true;
            });
          }
        });
        // 已选择的需要在右边，并且禁用
        // 处理左边
        this.liangbiaoTem.forEach((item: any) => {
          if (this.leftData[item.label]) {
            this.leftData[item.label].forEach((ele: any) => {
              const i = this.currentData.findIndex((val: any) => {
                return ele.template_id === val.template_id;
              });
              if (i != -1) {
                ele.hide = true;
              }
            });
          }
        });
        // 处理右边
        this.liangbiaoTem.forEach((item: any) => {
          if (this.rightData[item.label]) {
            this.rightData[item.label].forEach((ele: any) => {
              const i = this.currentData.findIndex((val: any) => {
                return ele.template_id === val.template_id;
              });
              if (i != -1) {
                ele.hide = false;
                ele.disabled = true;
              }
            });
          }
        });
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    this.ifLiangbiao = this.visible;
    if (this.visible) {
      this.getData();
    }
  }
}
